import {
  isHttpUri,
  isHttpsUri,
  isWebUri,
  isUri,
} from 'valid-url';

export function validateHttpUri(uri: string) : boolean {
  return isHttpUri(uri) === uri;
}

export function validateHttpsUri(uri: string) : boolean {
  return isHttpsUri(uri) === uri;
}

export function validateHttpHttpsUri(uri: string) : boolean {
  return isWebUri(uri) === uri;
}

export function validateUri(uri: string) : boolean {
  return isUri(uri) === uri;
}
